export default __webpack_public_path__ + "static/media/ngn.e2a6add4.svg";